export const reInfoOrgTypeConstants = {
	GetPaged: {
		SUCCESS : 'GET_PAGED_INFO_ORG_TYPE_SUCCESS',
		REQUEST : 'GET_PAGED_INFO_ORG_TYPE_REQUEST',
		FAILURE : 'GET_PAGED_INFO_ORG_TYPE_FAILURE'
	},
	GetPagedAudit: {
		SUCCESS : 'GET_PAGED_AUDIT_INFO_ORG_TYPE_SUCCESS',
		REQUEST : 'GET_PAGED_AUDIT_INFO_ORG_TYPE_REQUEST',
		FAILURE : 'GET_PAGED_AUDIT_INFO_ORG_TYPE_FAILURE'
	},
	GetPagedAll: {
		REQUEST : 'GET_PAGED_ALL_INFO_ORG_TYPE_REQUEST',
		SUCCESS : 'GET_PAGED_ALL_INFO_ORG_TYPE_SUCCESS',
		FAILURE : 'GET_PAGED_ALL_INFO_ORG_TYPE_FAILURE'
	},
	GetList: {
		REQUEST : 'GET_LIST_INFO_ORG_TYPE_REQUEST',
		SUCCESS : 'GET_LIST_INFO_ORG_TYPE_SUCCESS',
		FAILURE : 'GET_LIST_INFO_ORG_TYPE_FAILURE'
	},
	Create: {
		REQUEST : 'CREATE_INFO_ORG_TYPE_REQUEST',
		SUCCESS : 'CREATE_INFO_ORG_TYPE_SUCCESS',
		FAILURE : 'CREATE_INFO_ORG_TYPE_FAILURE'
	},
	Delete: {
		REQUEST : 'DELETE_INFO_ORG_TYPE_REQUEST',
		SUCCESS : 'DELETE_INFO_ORG_TYPE_SUCCESS',
		FAILURE : 'DELETE_INFO_ORG_TYPE_FAILURE'
	},
	Update: {
		REQUEST : 'UPDATE_INFO_ORG_TYPE_REQUEST',
		SUCCESS : 'UPDATE_INFO_ORG_TYPE_SUCCESS',
		FAILURE : 'UPDATE_INFO_ORG_TYPE_FAILURE'
	},
	Restore: {
		REQUEST : 'RESTORE_INFO_ORG_TYPE_REQUEST',
		SUCCESS : 'RESTORE_INFO_ORG_TYPE_SUCCESS',
		FAILURE : 'RESTORE_INFO_ORG_TYPE_FAILURE'
	},
	CLEAR: 'CLEAR_INFO_ORG_TYPE'
}